import _ from 'lodash'

export const formatSubs = (array, filed) => {
  return _.map(_.map(array, "subscription_plan"), filed);
};
